/**
 * Hook fuer Permission-basierte Zugriffskontrolle im Frontend.
 * Nutzt die vom Backend berechneten Permissions aus dem User-Objekt.
 */

import { useMemo } from 'react';
import { useAuth } from './useAuth';

export function usePermissions() {
  const { user } = useAuth();

  const permissions = useMemo(
    () => new Set(user?.permissions ?? []),
    [user?.permissions]
  );

  return {
    /** Prueft ob der User eine bestimmte Permission hat */
    hasPermission: (perm: string) => permissions.has(perm),

    /** Prueft ob der User mindestens eine der gegebenen Permissions hat */
    hasAnyPermission: (...perms: string[]) => perms.some((p) => permissions.has(p)),

    /** Prueft ob der User alle gegebenen Permissions hat */
    hasAllPermissions: (...perms: string[]) => perms.every((p) => permissions.has(p)),

    /** Prueft ob der User eine bestimmte Rolle hat */
    hasRole: (role: string) => user?.rollen?.some((r) => r.name === role) ?? false,

    /** Prueft ob der User mindestens eine der gegebenen Rollen hat */
    hasAnyRole: (...roles: string[]) =>
      roles.some((role) => user?.rollen?.some((r) => r.name === role)) ?? false,
  };
}
